import { useCallback } from 'react';
import api from '../services/api';
import Swal from 'sweetalert2';

interface CepData {
  setIbge: (value: string) => void;
  setCity: (value: string) => void;
  setAddress: (value: string) => void;
  setDistrict: (value: string) => void;
  setState: (value: string) => void;
  setNumber: (value: string) => void;
  setComplement: (value: string) => void;
}

export function useCepService(data: CepData) {
  const findCep = useCallback(async (cep: string, firstSearch?: boolean) => {
    if (!cep) return false;

    try {
      const response = await api.get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`);
      
      if (response.data.erro) {
        data.setCity("");
        data.setAddress("");
        data.setDistrict("");
        data.setState("");
        Swal.fire({
          icon: "warning",
          title: "CEP inválido!",
          text: "Verifique se o CEP foi digitado corretamente.",
        });
        return false;
      }

      data.setIbge(response.data.ibge || "");
      data.setCity(response.data.localidade || "");
      data.setAddress(response.data.logradouro || "");
      data.setDistrict(response.data.bairro || "");
      data.setState(response.data.uf || "");

      if (!firstSearch) data.setNumber("");
      data.setComplement("");
      
      return true;
    } catch (error) {
      data.setCity("");
      data.setAddress("");
      data.setDistrict("");
      data.setState("");
      Swal.fire({
        icon: "warning",
        title: "CEP inválido!",
        text: "Verifique se o CEP foi digitado corretamente.",
      });
      return false;
    }
  }, [data]);

  return { findCep };
}
